import React from 'react';
import { IconListItem } from '../../types';
import Modal from '../Modal';
import UniversalLink from '../UniversalLink';
import LessonIcon from '../LessonIcon';

interface Props {
    item: IconListItem,
    baseCol: number,
    largeCol: number,
}
interface State {
    showModal: boolean,
}

/* eslint-disable react/no-danger */

class Item extends React.Component<Props, State> {
    state = { showModal: false };

    static defaultProps = { baseCol: 6, largeCol: 4 };

    closeModal() {
        this.setState({
            showModal: false,
        });
    }

    render() {
        const { item, baseCol, largeCol } = this.props;
        const { showModal } = this.state;
        const { info } = item;

        let titleStyle = {};
        if (item.fontColor) {
            titleStyle = {
                color: item.fontColor,
            };
        }

        return (
            <div className={`col-${baseCol} col-lg-${largeCol}`}>
                <UniversalLink to={item.link}>
                    <div className="mental-icon">
                        <LessonIcon iconType={item.iconType} iconUrl={item.iconUrl} />
                    </div>
                    <div className="mental-name" style={titleStyle}>
                        {item.title}
                    </div>
                </UniversalLink>
                {info && (
                    <div className="mental-info">
                        <button
                            className="icon"
                            onClick={() => this.setState({ showModal: true })}
                            type="button"
                        >
                            <i
                                className="icon icon-info"
                            />
                        </button>
                    </div>
                )}
                {showModal && info ? (
                    <Modal
                        closeWindowCallback={() => this.closeModal()}
                        bodyStyle={{ backgroundColor: info.infoDialogLayout.headerColor.bgColor }}
                    >
                        <div
                            className="mental-info-header"
                        >
                            <div className="mental-icon">
                                <UniversalLink to={item.link} onClick={() => this.closeModal()}>
                                    <img src={item.iconUrl} alt="" />
                                </UniversalLink>
                            </div>
                            <div
                                className="mental-name"
                                style={{ color: info.infoDialogLayout.headerColor.fontColor }}
                            >
                                {info.title}
                            </div>
                        </div>
                        <img
                            src={info.infoDialogLayout.headerWaveUrl}
                            className="wave-separator"
                            alt=""
                        />
                        <div
                            className="mental-info-content"
                            style={{ backgroundColor: info.infoDialogLayout.bodyColor.bgColor }}
                        >
                            <p
                                style={{ color: info.infoDialogLayout.bodyColor.fontColor }}
                                dangerouslySetInnerHTML={{ __html: info.infoText }}
                            />
                        </div>
                    </Modal>
                ) : null}
            </div>
        );
    }
}

export default Item;
